const reviewActions = {
    SET_NEED_RESPONSE_COUNT: 'SET_NEED_RESPONSE_COUNT',
};

export default reviewActions;
